export default __webpack_public_path__ + "static/media/2.ce2f8fa8.jpeg";